var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39545",
    "data-name": "Path 39545",
    d: "M6.56,3.08a.628.628,0,0,0-.21-.24.6.6,0,0,0-.34-.11.34.34,0,0,0-.14.02.683.683,0,0,0-.42.31L4.19,5.25,3.46,6.51l-.48.84a.575.575,0,0,0-.04.45.587.587,0,0,0,.6.43H8.5a.526.526,0,0,0,.41-.2.615.615,0,0,0,.05-.78L6.55,3.07ZM6.37,7.67a.508.508,0,0,1-.36.15.547.547,0,0,1-.53-.53.514.514,0,0,1,.15-.37.529.529,0,0,1,.38-.16.519.519,0,0,1,.52.53.514.514,0,0,1-.15.37Zm.12-2.82c-.02.37-.05.74-.06,1.11A.418.418,0,0,1,6,6.38a.438.438,0,0,1-.43-.42V5.78c-.03-.4-.05-.8-.08-1.2a2.105,2.105,0,0,0-.02-.25V4.21A.5.5,0,0,1,5.6,3.8a.51.51,0,0,1,.55-.17.517.517,0,0,1,.37.43,1.218,1.218,0,0,1,0,.27l-.03.51Z",
    fill: "#db2725"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39546",
    "data-name": "Path 39546",
    d: "M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM9.95,7.89a1.811,1.811,0,0,1-.14.41,1.427,1.427,0,0,1-1.33.83H3.52A1.493,1.493,0,0,1,2.04,7.8a1.452,1.452,0,0,1,.21-.94l.62-1.08c.6-1.05,1.21-2.09,1.81-3.14a1.447,1.447,0,0,1,1.11-.77,1.422,1.422,0,0,1,1.42.62c.18.26.34.54.49.81.06.12.13.23.19.34L8.91,5.41l.82,1.41a2.128,2.128,0,0,1,.23.59v.42l-.01.06Z",
    fill: "#db2725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/FileError.0219593917356e39b1d6f0393030dcc6.svg";
export { ForwardRef as ReactComponent };